import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClientListPane } from '@apps/web/components/clients/client_list_pane';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

export const clientsSearchSchema = z.object({
    clientId: z.string().optional(),
    chatId: z.string().uuid().optional(),
    chatMode: z.enum(['fullscreen']).optional(),
    slackWebClaim: z.string().optional(),
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/clients')({
    component: ClientsPage,
    validateSearch: clientsSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Clients | Phoebe',
            },
        ],
    }),
});

function ClientsPage() {
    const {
        clientId,
        organizationId: deepLinkOrganizationId,
        mode: deepLinkMode,
    } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        deepLinkOrganizationId,
        deepLinkMode,
    );

    if (isWaitingForDeepLinkOrganization) {
        return null;
    }

    return <ClientListPane selectedClientId={clientId} />;
}
